<span
  [matTooltip]="
    timestamp
      ? ('tooltips.profileTimezone' | translate) +
        ' ' +
        (profileTimezone?.resolved
          ? (timestamp | locale : dateFormat : profileTimezone?.timezone : null : profileTimezone?.offset) +
            profileTimezoneText
          : ('tooltips.notResolved' | translate)) +
        '\n' +
        ('tooltips.localTimezone' | translate) +
        ' ' +
        (localTimezone?.resolved
          ? (timestamp | locale : dateFormat : localTimezone?.timezone : null : localTimezone?.offset) +
            localTimezoneText
          : ('tooltips.notResolved' | translate))
      : null
  "
  class="date-with-timezone__wrap"
>
  <ng-content></ng-content>
  <ui-svg-icon
    *ngIf="localTimezone?.resolved === false"
    [name]="iconNames.AlertInfo"
    [width]="16"
    class="timezone-alert tw-align-sub"
  ></ui-svg-icon>
  <ng-container *ngIf="localTimezone?.selected; else profileDateTemplate">
    {{ timestamp | locale : dateFormat : localTimezone?.timezone : null : localTimezone?.offset | nullToNotAvailable }}
  </ng-container>
  <ng-template #profileDateTemplate>
    {{
      timestamp | locale : dateFormat : profileTimezone?.timezone : null : profileTimezone?.offset | nullToNotAvailable
    }}
  </ng-template>
</span>
